<template>
  <ion-badge
    v-if="data.revoked"
    class="offline"
  >
    No
  </ion-badge>
  <ion-badge
    v-else
    class="online"
  >
    Yes
  </ion-badge>
</template>

<script>
export default {
  data() {
    return {
      data: {},
    }
  }
}
</script>